import { Model } from '@atds-legacy/data';
import { Record } from '@redge-media/fo-js-sdk';

const store = {
  isAvailable() {
    return (typeof global.Storage !== 'undefined');
  },
  getItem(key) {
    if (this.isAvailable()) {
      const val = localStorage.getItem(key);
      return val ? JSON.parse(val) : undefined;
    }
  },
  setItem(key, val) {
    if (this.isAvailable()) {
      localStorage.setItem(key, JSON.stringify(val));
    }
  },
  removeItem(key) {
    if (this.isAvailable()) {
      localStorage.removeItem(key);
    }
  },
};

export default class ModelLocal extends Model {
  initialize(attrs, options = {}) {
    this.namespace = options.namespace || 'app';
  }

  sync(method) {
    if (method === 'read') {
      return Promise.resolve(store.getItem(this.namespace));
    }

    if (method === 'create' || method === 'update') {
      return Promise.resolve(store.setItem(this.namespace, this.toJSON()));
    }

    if (method === 'delete') {
      return Promise.resolve(store.removeItem(this.namespace));
    }
  }
}

const ModelSession = Record.extend({
  constructor: function ModelSession(attrs, opts = {}) {
    Record.call(this, attrs, opts);
    this.namespace = opts.namespace;
  },

  getItem() {
    if (store.isAvailable()) {
      return JSON.parse(sessionStorage.getItem(this.namespace));
    }

    return undefined;
  },

  setItem(data) {
    if (store.isAvailable()) {
      sessionStorage.setItem(this.namespace, JSON.stringify(data));
    }
  },

  removeItem() {
    if (store.isAvailable()) {
      sessionStorage.removeItem(this.namespace);
    }
  },
});

export { ModelSession };
